import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "pb-0"
};
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "d-flex" };
const _hoisted_4 = {
    class: "text-end mt-2",
    style: { "padding-right": "11px" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_IconSwitcher = _resolveComponent("IconSwitcher");
    const _component_Icon = _resolveComponent("Icon");
    const _component_Section = _resolveComponent("Section");
    return (_openBlock(), _createBlock(_component_Section, { title: "Custom Visualizations" }, {
        default: _withCtx(() => [
            (_ctx.customStylesForDisplay.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("p", {
                            style: { "font-size": "14px" },
                            class: "mb-0"
                        }, "No custom visualizations defined.", -1)
                    ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customStylesForDisplay, ([name]) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: name,
                            class: "d-flex justify-content-between align-items-center mb-1 p-1 ps-2 border rounded"
                        }, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["flex-grow-1", { 'text-muted': !_ctx.isCustomStyleEnabled(name) }]),
                                style: { "font-size": "0.875rem" }
                            }, _toDisplayString(name), 3),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_IconSwitcher, {
                                    useFirst: true,
                                    iconID1: ['fa', 'pencil'],
                                    iconID2: ['fa', 'pencil'],
                                    icon2Style: { color: 'lightgray' },
                                    width: 22,
                                    onClick: ($event) => (_ctx.handleEditCustomStyle(name)),
                                    title: "Edit Visualization",
                                    class: "icon-spacing1 clickable"
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_IconSwitcher, {
                                    useFirst: _ctx.isCustomStyleEnabled(name),
                                    iconID1: ['far', 'eye'],
                                    iconID2: ['far', 'eye-slash'],
                                    icon2Style: { color: 'lightgray' },
                                    width: 22,
                                    onClick: ($event) => (_ctx.handleToggleCustomStyle(name)),
                                    title: "Toggle Visualization",
                                    class: "icon-spacing2 clickable"
                                }, null, 8, ["useFirst", "onClick"]),
                                _createVNode(_component_IconSwitcher, {
                                    useFirst: true,
                                    iconID1: ['far', 'rectangle-xmark'],
                                    iconID2: ['far', 'rectangle-xmark'],
                                    width: 22,
                                    onClick: ($event) => (_ctx.handleDeleteCustomStyle(name)),
                                    title: "Delete Visualization",
                                    class: "clickable"
                                }, null, 8, ["onClick"])
                            ])
                        ]));
                    }), 128))
                ])),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.openAddNewVisualizationPlugin && _ctx.openAddNewVisualizationPlugin(...args))),
                    role: "button",
                    tabindex: "0",
                    title: "Add New Visualization",
                    class: "clickable",
                    style: { "font-size": "1.1rem", "text-decoration": "none" }
                }, [
                    _createVNode(_component_Icon, { icon: ['fas', 'plus'] })
                ])
            ])
        ]),
        _: 1
    }));
}
